import { SORT_RESULTS_KEYNAME } from "@/common/consts";
import { readLocalStorage, writeLocalStorage } from "./localStorageUtils";

export const writeSortResults = (sorting) => {
	writeLocalStorage(SORT_RESULTS_KEYNAME, sorting);
};

export const readSortResults = () => {
	const stub = [{ sortResults: "wordlength" }];
	return navigator.cookieEnabled
		? readLocalStorage(SORT_RESULTS_KEYNAME)
		: stub;
};

/**
 *  Sort object keys
 *
 * @param {Object} obj the words object what should be sorted by descending
 * @return {Array} array of sorted object keys by descending
 */
export const sortObjectKeys = (obj) => {
	return Object.keys(obj)
		.filter((k) => obj[k])
		.sort((a, b) => {
			const lettersRegex = /[^\d]/g;
			const getNum = (str) => Number(str.replace(lettersRegex, ""));
			return getNum(b) - getNum(a);
		});
};
